export const environment = {
  production: true,
  isMyParkingDeployment: true,
  apiBaseUrl: 'https://asia-southeast1-parkbot-ph-prd.cloudfunctions.net'
};

export const firebaseConfig = {
  
  // apiKey: "AIzaSyDOsJu1tOGTRvs9tOPeSQpcC05PpF679I0",
  // authDomain: "parkbotph-staging.firebaseapp.com",
  // projectId: "parkbotph-staging",
  // storageBucket: "parkbotph-staging.appspot.com",
  // messagingSenderId: "462181268030",
  // appId: "1:462181268030:web:5c37951655186046b8af6f",
  // measurementId: "G-BDQLZJSLQ9"

  apiKey: "AIzaSyDH1lKVYFSGgQCamc9-00XIn3b2Lci-QyY",
  authDomain: "parkbot-ph-prd.firebaseapp.com",
  projectId: "parkbot-ph-prd",
  storageBucket: "parkbot-ph-prd.appspot.com",
  messagingSenderId: "787780322172",
  appId: "1:787780322172:web:426cb63a2eff9afd9cdaf9",
  measurementId: "G-J2GV5FQX23"
}

export const mayaConfig = {
  sandbox: {
    publicKey: 'pk-TESAywkgaqgiR6QQT99Ijqaj5yORzrGNSnhFPQbxDLe',
    secretKey: 'sk-o6NgcG7gmgHpd7SZ57sDZHYZbiE0Cq87kiYkE9ENKre',
    baseUrl: 'https://pg-sandbox.paymaya.com'
  },
  production: {
    publicKey: 'pk-eLZYDZIXW5qNpc6NHUKBPJE6RfIlo9yMfoBVYcOXpew',
    secretKey: 'sk-epKw4D8Yi6YLO5emAyaUcxBKnfkhzKZZImZqO4YLphT',
    baseUrl: 'https://pg.paymaya.com'
  }
}